/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type ContentStackSegmentation } from '../interface';

export function matchesSegment(
  userSegments: string[] | undefined,
  contentSegments: ContentStackSegmentation['segment'],
) {
  return contentSegments?.every((segment) => userSegments?.includes(segment));
}
